import * as CubiqTS from "shared/cubiq-model-multi-asset";

import { IStatefulCellAdapter } from "../IStatefulCellAdapter";
import { StringAdapter } from "../StringAdapter";
import { ColumnDefinition } from "../../model/ColumnDefinition";
import { OrderTypeAdapter } from "../common/OrderTypeAdapter";
import { AlgoStrategyLookupService } from "../../lookup/model/impl/AlgoStrategyLookupService";
import { SystemConfigPromiseService } from "shared/auth-services";
import { BfxSysConfigUtilService } from "shared/auth-services";

export class FillAwareOrderTypeAdapter extends OrderTypeAdapter {
  // This is only valid for CubiqTS.OrderData
  protected readonly columnProperty = "requestedOrderType";

  constructor(
    protected _partFillDisabledTypeText,
    protected _algoStrategyLookup: AlgoStrategyLookupService,
    _sysConfigService: SystemConfigPromiseService,
    sysConfigUtilService: BfxSysConfigUtilService,
  ) {
    super(_sysConfigService, sysConfigUtilService);
  }

  adapt(column: ColumnDefinition, row: any, ...modelObjects: any[]): void {
    super.adapt(column, row, ...modelObjects);
  }

  retrieveData(order: CubiqTS.OrderDataImpl, columnProperty: string, html: boolean = true): string {
    let orderType: any = order[this.columnProperty];
    if (orderType != undefined && orderType != null) {
      let retStr: string = this.retrieveSearch(order, this.columnProperty);

      if (true == html) {
        if (
          CubiqTS.RequestOrderType.SL_ASK === orderType ||
          CubiqTS.RequestOrderType.SL_ATRATE === orderType ||
          CubiqTS.RequestOrderType.SL_BID === orderType ||
          CubiqTS.RequestOrderType.TSL === orderType ||
          CubiqTS.RequestOrderType.TSL_ASK === orderType ||
          CubiqTS.RequestOrderType.TSL_BID === orderType ||
          (CubiqTS.RequestOrderType.ALGO == orderType &&
            CubiqTS.OrderType.LIMIT_SL == order.monitoringOrderType)
        ) {
          retStr = '<span class="order-type order-type-sl">' + retStr + "</span>";
        }
      }

      return retStr;
    }

    return "-";
  }

  retrieveSort(order: any, columnProperty: string): string {
    return this.retrieveSearch(order, this.columnProperty);
  }

  retrieveSearch(order: CubiqTS.OrderDataImpl, columnProperty: string): string {
    let retStr;
    if (
      (order.requestedOrderType === CubiqTS.RequestOrderType.ALGO ||
        order.requestedOrderType === CubiqTS.RequestOrderType.BMALGO) &&
      typeof order.algoStrategyName === "string"
    ) {
      let algoStrategyDescription = this.getAlgoStrategyDescription(order);
      if (algoStrategyDescription !== null) {
        return algoStrategyDescription;
      }
      return order.algoStrategyName;
    } else {
      retStr = this.getValue(order);
    }

    if (
      CubiqTS.FillSupport.ALL_OR_NOTHING === (order as CubiqTS.OrderData).executionInstruction &&
      (order as CubiqTS.OrderData).requestedOrderType !== CubiqTS.RequestOrderType.BMARK &&
      (order as CubiqTS.OrderData).requestedOrderType !== CubiqTS.RequestOrderType.BMALGO &&
      this._partFillDisabledTypeText
    ) {
      return `${retStr} ${this._partFillDisabledTypeText}`;
    }

    return retStr;
  }

  retrieveFilter(order: any, columnProperty: string): string {
    return CubiqTS.RequestOrderType.ALGO === order.requestedOrderType &&
      typeof order.algoStrategyName === "string"
      ? order.algoStrategyName
      : CubiqTS.RequestOrderType[order[columnProperty]];
  }

  getAlgoStrategyDescription(order: any) {
    let algoStrategyName = order.algoStrategyName;

    if (this._algoStrategyLookup.hasAlgoStrategy(algoStrategyName)) {
      let algoStrategy = this._algoStrategyLookup.getAlgoStrategy(algoStrategyName);

      if (algoStrategy && typeof algoStrategy.description === "string")
        return algoStrategy.description;
    }

    return null;
  }
}
